// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-HBhj1 {
  width: 800px;
  height: 80px;
  margin-inline: auto;
  background-color: coral;
  color: #FF0000;
}
.header-e81m9 {
  display: flex;
  gap: 20px;
}
.logo-iSgEj {
  max-width: 200px;
}
.main-uqHOh {
  flex: 1;
}
.cart-hSxx7 {
  max-width: 200px;
  background-color: #FFFFFF;
}
`, "",{"version":3,"sources":["webpack://./src/components/EmdbComponent/emdbComponent.module.less"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AACJ;AACA;EAAQ,aAAA;EAAe,SAAA;AAGvB;AAFA;EAAM,gBAAA;AAKN;AAJA;EAAM,OAAA;AAON;AANA;EAAM,gBAAA;EAAkB,yBAAA;AAUxB","sourcesContent":[".test {\n    width: 800px;\n    height: 80px;\n    margin-inline: auto;\n    background-color: coral;\n    color: #FF0000;\n}\n.header{display: flex; gap:20px;}\n.logo{max-width: 200px;}\n.main{flex: 1; }\n.cart{max-width: 200px; background-color: #FFFFFF;}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"test": `test-HBhj1`,
	"header": `header-e81m9`,
	"logo": `logo-iSgEj`,
	"main": `main-uqHOh`,
	"cart": `cart-hSxx7`
};
export default ___CSS_LOADER_EXPORT___;
